import { select, takeLeading } from 'redux-saga/effects';
import { AppState } from '../appState';
import { UPLOAD_CANCEL } from './types';

function* cancelUpload() {
    const cancelTokenSource = yield select((state: AppState) => state.upload.cancelTokenSource);
    cancelTokenSource?.cancel();
}

// eslint-disable-next-line import/no-anonymous-default-export
export default [takeLeading(UPLOAD_CANCEL, cancelUpload)];
